<template>
    <div class="scope-12">
        <div class="top-img">
            <img :src="activeUrl" alt="" ref="topimg" v-if="getType(activeUrl)">
            <iframe :src="activeUrl" ref="topimg" v-else></iframe>
        </div>
        <div class="cope12-bg"></div>
        <div class="img-list">
            <div class="img-area" ref="imgarea">
                <div class="img-text">{{ defaultdata[activeIndex].value2 }}</div>
                <div class="left-btn" @click="pre" v-if="defaultdata.length > 4">
                    <img src="@/assets/temimg3/icon-left.png" alt="">
                </div>
                <div class="right-btn" @click="next" v-if="defaultdata.length > 4">
                    <img src="@/assets/temimg3/icon-right.png" alt="">
                </div>
                <div class="img-item" v-for="(item, i) in defaultdata" :key="i" @click="selectImg(i)">
                    <img :src="item.value1" alt="">
                    <img class="img-active" src="@/assets/temimg3/img-active.png" alt="" v-if="i == activeIndex">
                    <img class="img-bg" src="@/assets/temimg3/img-bg.png" alt="" v-else>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import defaultimg from '@/assets/temimg3/default-img.jpg'
export default {
    name: "template.scope12",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
		jsondata: {
			type: [Array, String],
			default: () => []
		}
    },
    data() {
        return {
            activeIndex: 0,
            activeUrl: defaultimg,
            title: '园区鸟瞰',
            timerout: 5,
            timer1: null,
            defaultdata: [
                { value1: 'http://121.4.173.197:8000/defaultimg/default1.jpg', value2: '园区鸟瞰', value3: 5 },
                { value1: 'http://121.4.173.197:8000/defaultimg/default2.jpg' },
                { value1: 'http://121.4.173.197:8000/defaultimg/default3.jpg' },
                { value1: 'http://121.4.173.197:8000/defaultimg/default4.jpg' },
                { value1: 'http://121.4.173.197:8000/defaultimg/default5.jpg' },
                { value1: 'http://121.4.173.197:8000/defaultimg/default6.jpg' },
                { value1: 'http://121.4.173.197:8000/defaultimg/default7.jpg' },
            ],
            valueMap: [
                { name: '图片地址', key: "value1" },
                { name: '标题', key: "value2" },
                { name: '轮播间隔(秒)', key: 'value3' }
            ],
			exceldata: []
        }
    },
    watch: {
        vdata(n) {
            if(n && n.length) {
                this.defaultdata = n
                this.title = n[0].value2
                this.timerout = n[0].value3
                this.activeIndex = 0
                this.selectImg(0)
                this.autoPlay()
            }
        },
        jsondata(n) {
            if(n && n.length) {
                this.exceldata = n
            }
        }
    },
    methods: {
        pre() {
            const dom = this.$refs.imgarea
            let leftcont = dom.scrollLeft - 848
            dom.scrollTo({
                left: leftcont,
                behavior: 'smooth'
            })
        },
        next() {
            const dom = this.$refs.imgarea
            let leftcont = dom.scrollLeft + 848
            dom.scrollTo({
                left: leftcont,
                behavior: 'smooth'
            })
        },
        selectImg(index) {
            if (index == this.activeIndex) return
            const dom = this.$refs.topimg
            const dom2 = this.$refs.imgarea
            this.activeIndex = index
            if(index == 0) {
                dom2.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                })
            } else {
                const page = Math.floor(index / 4)
                if (dom2.scrollLeft < page * 848) {
                    dom2.scrollTo({
                        left: page * 848,
                        behavior: 'smooth'
                    })
                }
            }
            this.activeUrl = this.defaultdata[index].value1
            dom.style.display = 'none'
            setTimeout(() => {
                dom.style.display = 'block'
            }, 100);
        },
        autoPlay() {
            clearInterval(this.timer1)
            this.timer1 = null
            this.timer1 = setInterval(() => {
                if (this.activeIndex < this.defaultdata.length - 1) {
                    const index = this.activeIndex + 1
                    this.selectImg(index)
                } else {
                    const index =  0
                    this.selectImg(index)
                }
            }, this.timerout * 1000);
        },
        getType(url) {
            const newurl = url.toString()
            return /(jpg|png)/i.test(newurl);
        }
    },
    mounted() {
        let host = window.location.host
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
            this.title = this.defaultdata[0].value2
            this.timerout = +this.defaultdata[0].value3
        }
        if (host == 'www.17886.cn') {
            let news = 'https://www.17886.cn'
            let olds = 'http://121.4.173.197:8000'
            this.defaultdata.forEach(item => {
                if (item.value1.includes(olds)) {
                    item.value1 = item.value1.replace(olds, news)
                }
            })
            this.defaultdata = [...this.defaultdata]
        }
        this.activeUrl = this.defaultdata[0].value1
        this.autoPlay()
    },
    beforeDestroy() {
        clearInterval(this.timer1)
        this.timer1 = null
    }
}
</script>

<style lang="scss">
.scope-12 {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    .top-img {
        img,
        iframe {
            width: 1920px;
            height: 1080px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            opacity: 0;
            animation: imgshow 0.5s linear;
            animation-fill-mode: forwards;
        }
    }
    @keyframes imgshow {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    .cope12-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        background: url(@/assets/temimg3/mask-img.png) no-repeat;
        background-size: 100% 100%;
    }
    .img-list {
        width: 875px;
        height: 264px;
        background: url(@/assets/temimg3/sope-btm.png) no-repeat;
        background-size: 100% 100%;
        margin: auto auto 100px;
        position: relative;
        z-index: 2;
    }
    .img-area {
        display: flex;
        column-gap: 18px;
        overflow-x: auto;
        margin-top: 114px;
        padding: 24px;
        &::-webkit-scrollbar {
            height: 0;
        }
        .img-item {
            width: 196px;
            min-width: 196px;
            height: 138px;
            cursor: pointer;
            position: relative;
            img {
                width: 100%;
                height: 100%;
            }
            .img-active,
            .img-bg {
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
            }
            .img-active {
                width: 222px;
                height: 165px;
                left: -13px;
                top: -13px;
            }
        }
    }
    .left-btn,
    .right-btn {
        position: absolute;
        bottom: 40px;
        width: 32px;
        height: 42px;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .left-btn {
        left: -45px;
    }
    .right-btn {
        right: -35px;
    }
    .img-text {
        font-family: PangMenZhengDao;
        font-weight: 400;
        font-size: 24px;
        color: #EDF7FF;
        line-height: 20px;
        position: absolute;
        top: 79px;
        left: 50%;
        transform: translateX(-50%);
        letter-spacing: 12px;
    }
}
</style>